'use client';
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index_js = require('use-sync-external-store/shim/index.js');

const useSyncExternalStore = index_js.useSyncExternalStore;

exports.useSyncExternalStore = useSyncExternalStore;
//# sourceMappingURL=useSyncExternalStore.js.map
